/* Inspired from MaterialUI:
https://github.com/mui-org/material-ui/tree/master/packages/material-ui/src/RootRef */
import React from 'react';
import ReactDOM from 'react-dom';

export interface RootRefProps {
  /** */
  // eslint-disable-next-line @typescript-eslint/ban-types
  rootRef: Function | React.MutableRefObject<Element | Text | null> | null;
  /** Children of RootRef component */
  children: React.ReactNode;
}

/** Record an HTML dom node to a ref */
function setRef(
  // eslint-disable-next-line @typescript-eslint/ban-types
  ref: Function | React.MutableRefObject<Element | Text | null> | null,
  value: Element | Text | null
) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
}

/**
 * A reference to the root of the position component
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
class RootRef extends React.PureComponent<RootRefProps> {
  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    setRef(this.props.rootRef, ReactDOM.findDOMNode(this));
  }

  componentDidUpdate(prevProps: RootRefProps) {
    if (prevProps.rootRef !== this.props.rootRef) {
      setRef(prevProps.rootRef, null);
      // eslint-disable-next-line react/no-find-dom-node
      setRef(this.props.rootRef, ReactDOM.findDOMNode(this));
    }
  }

  componentWillUnmount() {
    setRef(this.props.rootRef, null);
  }

  render() {
    return this.props.children;
  }
}

export default RootRef;
